import { useEffect, useState } from 'react'
import { useApiClient } from './useApiClient.js'
import { fetchProtectedBlobUrl } from './uploads.js'

// Object-URL hook for auth-gated seller media (contract §5:
// GET /api/v1/seller-media/{media_id}/file — Cache-Control: private, no-store).
// Private or scheduled-future items are no longer served by public /media/{path},
// so protected renders fetch the bytes with the bearer token and display an
// object URL instead. The URL is revoked on unmount / id change / disable.
//
//   const { url, loading, error } = useProtectedMediaUrl(item.id, { enabled: !item.is_public })
//
// Pass enabled: false for public+published items so they keep using the
// cacheable mediaUrl(path) directly.
export function useProtectedMediaUrl(mediaId, { enabled = true } = {}) {
  const api = useApiClient()
  const active = enabled && mediaId != null
  const [state, setState] = useState({ url: null, loading: active, error: null })

  useEffect(() => {
    if (!active) {
      setState({ url: null, loading: false, error: null })
      return undefined
    }

    let cancelled = false
    let objectUrl = null
    setState({ url: null, loading: true, error: null })

    fetchProtectedBlobUrl(api, `/api/v1/seller-media/${mediaId}/file`)
      .then((url) => {
        if (cancelled) {
          // Effect already cleaned up — nothing will ever render this URL.
          URL.revokeObjectURL(url)
          return
        }
        objectUrl = url
        setState({ url, loading: false, error: null })
      })
      .catch((err) => {
        if (!cancelled) setState({ url: null, loading: false, error: err })
      })

    return () => {
      cancelled = true
      if (objectUrl) URL.revokeObjectURL(objectUrl)
    }
  }, [api, mediaId, active])

  return state
}
